import { ObjectUpdate } from '../../../concepts/objects';
import { Matrix } from '../../../platform/geom/Matrix';
import { Figure } from '../../canvas/entities/Physical';
import { CreatePhysicalToolBehavior, CreateTransformableDragParams } from '../../canvas/tooling/CreatePhysicalToolBehavior';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { ColorGroup } from './../../../ui';
import { Shape } from './Shape';
import { ShapeKind } from './ShapeEnums';

const arrowKinds = [
    ShapeKind.arrow1,
    ShapeKind.arrow2,
    ShapeKind.arrow3,
];

class CreateShapeToolBehavior extends CreatePhysicalToolBehavior(Shape, 'drag') {

    protected createSubject(u: ObjectUpdate) {
        const shape = super.createSubject(u);
        if (this.settings.kind) shape.kind = this.settings.kind;
        if (this.settings.sides) shape.sides = this.settings.sides;
        if (this.settings.style) shape.style = this.settings.style;
        if (this.settings.stroke) shape.stroke = this.settings.stroke;
        shape.background = this.settings.color ?? ColorGroup.default[3];
        shape.width = (this.settings.width ?? 1) * 200;
        shape.height = (this.settings.height ?? 1) * 200;
        return shape;
    }

    protected applyDrag(shape: Shape, drag: CreateTransformableDragParams) {
        if (arrowKinds.includes(shape.kind)) {
            const ln = drag.line(this.grid);
            const mt = Matrix
                .translate(ln.p1)
                .rotate(ln.toVector().angle())
                .scale(ln.length, Math.min(Math.max(20, ln.length * .1), 200))
                .translate(0, -.5);
            shape.setFromFigure(mt.apply(Figure.unit));
        }
        else {
            super.applyDrag(shape, drag);
        }
    }

    protected shouldConsume() {
        return true;
    }

    protected shouldForceSnap() {
        return true;
    }

    protected shouldForceFix() {
        return false;
    }
}

export const shapeTool = defineToolWithCommonBehaviors({
    id: 'shapeTool',
    label: 'Shapes',
    category: 'design',
    icon: 'deqo://icons/d2/shapes',
    weight: 3010,
    shortcut: 'S',
    behaviors: [
        CreateShapeToolBehavior,
    ]
});

